<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link v-if="checkPermission('AddAlaUne')"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          to="/ajouter-alaUne"
        >
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          Ajouter
        </router-link>
        <!-- <button
          class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
        >
          Exporter
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button> -->
      </div>
      <div class="d-flex align-items-center">
       <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher un alaUne"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
        <!-- <button
          class="dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block"
          type="button"
        >
          <i class="flaticon-dots"></i>
        </button> -->
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Image
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Sous titre
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Titre
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Description
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Lien
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Statut
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
              >ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(alaUne, index) in alaUnes" :key="index">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <img :src="getUrlApiForFiles(alaUne.urlImage)" alt="Image" width="100" height="100">
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis" style="max-width: 180px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                {{ alaUne.subtitle?.length > 40 ? alaUne.subtitle.slice(0, 40) + '...' : alaUne.subtitle }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis" style="max-width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                {{ alaUne.titre?.length > 40 ? alaUne.titre.slice(0, 40) + '...' : alaUne.titre }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis" style="max-width: 220px;">
                <div v-html="alaUne.description" style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis; line-height: 1.5;">
                </div>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ alaUne.link }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span :class="alaUne.statut ? 'badge text-white bg-success' : 'badge text-white bg-secondary'">
                  {{ alaUne.statut ? 'Actif' : 'Inactif' }}
                </span>
              </td>
              <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0"
              >
              <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li v-if="checkPermission('EditAlaUne')">
                      <router-link :to="{ name: 'EditAlaUnePage', params: { id: alaUne.id } }" 
                          class="dropdown-item d-flex align-items-center"><i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>Modifier</router-link>
                    </li>
                    <li v-if="checkPermission('ViewAlaUne')">
                        <router-link :to="{ name: 'ViewAlaUnePage', params: { id: alaUne.id } }" class="dropdown-item d-flex align-items-center">
                            <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>Détails
                        </router-link>
                    </li>
                    <li v-if="checkPermission('DeleteAlaUne')">
                      <a
                        class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="suppression(alaUne.id,alaUnes,'alaUnes',`l\'alaUne ${alaUne.id}`)">
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1" ></i>
                         Supprimer
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                        @click="switchAlaUne(alaUne.id)">
                        <i :class="alaUne.statut ? 'flaticon-close lh-1 me-8 position-relative top-1' : 'flaticon-check-mark lh-1 me-8 position-relative top-1'"></i>
                        {{ alaUne.statut ? 'Désactiver' : 'Activer' }}
                      </a>
                    </li>
                  </ul>
              </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref} from "vue";
import Swal from "sweetalert2";
import { AlaUne } from "../../models/AlaUne";
import ApiService from "../../services/ApiService";
import { suppression, error, getUrlApiForFiles } from "../../utils/utils";
import PaginationComponent from '../../components/Utilities/Pagination.vue';
import JwtService from "../../services/JwtService";

export default defineComponent({
  name: "ListeAlaUne",
  components: {
    PaginationComponent
  },
  setup(){
    onMounted(() => {
      getAllAlaUne();
    });

    const alaUnes = ref<Array<AlaUne>>([]);   
    const alaUne = ref<AlaUne>();

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllAlaUne(page_, limit_);
      } catch (error) {
        //
      }
    };

     function rechercher(){
      getAllAlaUne(page.value, limit.value, searchTerm.value );
    }

    // END PAGINATE

    function getAllAlaUne(page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/alaUnes?page=${page}&limit=${limi}&mot=${searchTerm}&`)
      //return ApiService.get('/alaUnes')
        .then(({ data }) => {
          alaUnes.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message)
      });
    }
    
    function moddifier(EditalaUne:AlaUne) {
      alaUne.value = EditalaUne;
    }

    const deletealaUne = (id: number) => {
      ApiService.delete(`/alaUnes/${id}`)
      .then(({ data }) => {
        Swal.fire({
          text: data.message,
          toast: true,
          icon: 'success',
          title: 'General Title',
          animation: false,
          position: 'top-right',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          heightAuto: false
        });
      })
      .catch(({ response }) => {
        Swal.fire({
          text: response.data.message,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Réssayer à nouveau!",
          heightAuto: false,
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        });
      });

      for(let i = 0; i < alaUnes.value.length; i++) {
        if (alaUnes.value[i].id === id) {
          alaUnes.value.splice(i, 1);
        }
      }
    };

    

    const switchAlaUne = (id: number) => {
      ApiService.put(`/alaUnes/switch/${id}`, {})
        .then(({ data }) => {
          Swal.fire({
            text: data.message,
            toast: true,
            icon: 'success',
            title: data.data.statut ? 'Publication activée' : 'Publication désactivée',
            animation: false,
            position: 'top-right',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            heightAuto: false,
          });
          // Mise à jour locale du statut sans recharger toute la liste
          const item = alaUnes.value.find(a => a.id === id);
          if (item) item.statut = data.data.statut;
        })
        .catch(({ response }) => {
          Swal.fire({
            text: response.data.message,
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: 'Réessayer',
            heightAuto: false,
            customClass: { confirmButton: 'btn fw-semobold btn-light-danger' },
          });
        });
    };

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }

    return { alaUnes,
      checkPermission,
     getAllAlaUne,
     deletealaUne,
     moddifier ,
     suppression,
     switchAlaUne,
     page, 
    totalPages,
    limit,
    totalElements,
    handlePaginate,
    rechercher,
    searchTerm,
    getUrlApiForFiles,
  };

  }
});
</script>